import './TabBenFinales.scss'
import { Col, Icon, Row, Table } from 'antd'
import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import {getFormC57Promise} from '../../promises'
import { camelizerHelper } from '../../../../helpers'
import moment from 'moment'
import apiConfig from '../../../../config/api'

const TabBenFinales = ({currentUser}) => {
    const { t } = useTranslation(["translations", "forms"])

    const [formC57Data, setFormC57Data] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const isInactiveUser = currentUser?.status === 'INACTIVE';

    useEffect(() => {
        handleRefresh()
    }, []);

    const handleRefresh = () => {
        setIsLoading(true)
        getFormC57Promise(currentUser.id).then(response => {
            setFormC57Data(response.data)
        }).finally(() => {
            setIsLoading(false)
        })
    }

    const completeForm = (item) => {
        if (isInactiveUser) {
            return
        }
        window.open(apiConfig.urlAml + '/ubo/formC57FI?formId=' + item.id + '&formInterno=' + false)
    }

    const c57Columns = [
        {  
            title: t('messages.aml.status'),
            dataIndex: 'status',
            align: 'center',
            render: (text) => {
                return <span>{camelizerHelper(text)}</span>
            }
        },
        {  
            title: t('messages.aml.shippingDate'),
            dataIndex: 'fecEnvio',
            align: 'center',
            render: (text) => {
                return <span>{moment(text).format('DD/MM/YYYY hh:mm')}</span>
            }
        },
        {  
            title: t('messages.aml.receiveDate'),
            dataIndex: 'fecRecibido',
            align: 'center',
            render: (text) => {
                return text && <span>{moment(text).format('DD/MM/YYYY hh:mm')}</span>
            }
        },
        {  
            title: t('messages.aml.deadlineDate'),
            dataIndex: 'fecPlazo',
            align: 'center',
            render: (text) => {
                return <span>{moment(text).format('DD/MM/YYYY')}</span>
            }
        },
        {  
            title: '',
            align: 'center',
            render: (item) => {
                if(item.status === 'ENVIADO') {
                    if (isInactiveUser) {
                        return null
                    }
                    return (
                    <Icon 
                        type='edit' 
                        style={{fontSize:20}}
                        onClick={() => {
                            completeForm(item)
                        }}
                    />
                    )
                }else {
                    return (
                    <Icon 
                        type='file-pdf' 
                        style={{fontSize:20}}
                        onClick={() => {
                            window.open(apiConfig.url + '/ubo/pdfFormUF/' + item.id)
                        }}
                    />
                    )
                }
            }
        }
    ]

  return (
    <div className='tab-ben-finales-stakeholder'>
        <div className="section">
            <Row>
                <Col span={23}>
                    <h3>{t('messages.aml.record')}</h3>
                </Col>
                <Col span={1} style={{textAlign:'right'}}>
                    <Icon 
                        type='reload' 
                        style={{fontSize: '20px'}}
                        onClick={() => handleRefresh()}
                    />
                </Col>
                <Col span={24}>
                    <Table dataSource={formC57Data} columns={c57Columns} loading={isLoading}/>
                </Col>
            </Row>
        </div>
    </div>
  )
}

export default TabBenFinales